import { render, staticRenderFns } from "./my-orders.vue?vue&type=template&id=f2b4efa6&"
import script from "./my-orders.vue?vue&type=script&lang=js&"
export * from "./my-orders.vue?vue&type=script&lang=js&"
import style0 from "./my-orders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports